import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const DEFAULT_MAX_CONCURRENT = 5;

interface GenerationLimiterState {
  activeCount: number;

  incrementActive: () => void;
  decrementActive: () => void;
  checkCanSubmit: (opts?: { maxConcurrent?: number }) => {
    allowed: boolean;
    reason?: string;
  };
}

export const useGenerationLimiterStore = create<GenerationLimiterState>()(
  devtools(
    (set, get) => ({
      activeCount: 0,

      incrementActive: () => set((state) => ({ activeCount: Math.max(0, state.activeCount + 1) })),

      decrementActive: () => set((state) => ({ activeCount: Math.max(0, state.activeCount - 1) })),

      checkCanSubmit: (opts) => {
        const maxConcurrent = opts?.maxConcurrent ?? DEFAULT_MAX_CONCURRENT;
        const { activeCount } = get();
        if (activeCount >= maxConcurrent) {
          return {
            allowed: false,
            reason: `已有 ${maxConcurrent} 个生成任务在进行中，请等待任务完成后再提交`,
          };
        }
        return { allowed: true };
      },
    }),
    { name: 'generationLimiterStore' }
  )
);
